<div class="row left-margin right-margin">
	<div class="col-md-12">
		@if (testSuites?.length > 0) {
			<div class="col-md-10">
				<h2>Test runs for test suite: {{ this.activeTestSuite?.itemNo }} - {{ this.activeTestSuite?.name }}&nbsp;</h2>
				<span class="small-font-italic">Select test run to view test results</span>
			</div>
			<div class="col-md-2 align-right no-padding">
				<div class="col-md-12 no-padding">
					<input type="text" id="txtSearchTestSuite" class="form-control" placeholder="Filter..." (keyup)="applyFilter($event)" />
				</div>
			</div>
			<div class="col-md-12 mat-elevation-z0">
				<table mat-table [dataSource]="dataSource" matSort>
					<ng-container matColumnDef="testRun.testRunUid">
						<th mat-header-cell *matHeaderCellDef mat-sort-header width="15%">Test run UID</th>
						<td mat-cell *matCellDef="let element">{{ element.testRun?.testRunUid }}</td>
					</ng-container>
					<ng-container matColumnDef="testRun.environment">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Environment</th>
						<td mat-cell *matCellDef="let element">{{ element.testRun?.environment }}</td>
					</ng-container>
					<ng-container matColumnDef="testSuiteVersion">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Test suite version</th>
						<td mat-cell *matCellDef="let element">{{ element.testSuiteVersion }}</td>
					</ng-container>
					<ng-container matColumnDef="testRun.executionTime">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Execution time</th>
						<td mat-cell *matCellDef="let element">{{ element.testRun?.executionTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
					</ng-container>
					<ng-container matColumnDef="testRun.regBy">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Executed by</th>
						<td mat-cell *matCellDef="let element">{{ element.testRun?.regBy }}</td>
					</ng-container>
					<ng-container matColumnDef="testSuite.name">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Main test suite</th>
						<td mat-cell *matCellDef="let element">{{ element.testSuite?.name === this.activeTestSuite?.name ? '-' : element.testSuite?.name }}</td>
					</ng-container>
					<ng-container matColumnDef="testSuite.version">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Main test suite version</th>
						<td mat-cell *matCellDef="let element">{{ element.testSuite?.name === this.activeTestSuite?.name ? '-' : element.testSuite?.version }}</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr
						mat-row
						*matRowDef="let row; columns: displayedColumns"
						[ngClass]="{ hovered: row.hovered }"
						(focus)="row.hovered = true"
						(focus)="row.hovered = true"
						(mouseover)="row.hovered = true"
						(blur)="row.hovered = false"
						(blur)="row.hovered = false"
						(mouseout)="row.hovered = false"
						(click)="navigateTo(row)"
					></tr>
				</table>
				<mat-paginator [pageSizeOptions]="getPageSizeOptions()" showFirstLastButtons></mat-paginator>
			</div>
		} @else if (testSuites?.length === 0) {
			<h4>There are no test runs for this test suite.</h4>
		}
	</div>
</div>
